export const client_id = process.env.REACT_APP_A0_CLIENT_ID
export const audience = process.env.REACT_APP_A0_API_AUDIENCE
export const domain = process.env.REACT_APP_A0_DOMAIN
export const redirect = process.env.REACT_APP_A0_REDIRECT
export const schema = process.env.REACT_APP_SCHEMA
